/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1PersonIdContactDataMutationRequest,
  PutApiV1PersonIdContactDataMutationResponse,
  PutApiV1PersonIdContactDataPathParams,
  PutApiV1PersonIdContactData400,
  PutApiV1PersonIdContactData401,
  PutApiV1PersonIdContactData404,
  PutApiV1PersonIdContactData500,
} from "../../types/personRegisterController/PutApiV1PersonIdContactData.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1PersonIdContactData } from "../../clients/personRegisterController/putApiV1PersonIdContactData.ts";

export const putApiV1PersonIdContactDataMutationKey = () =>
  [{ url: "/api/v1/person/:id/contact-data" }] as const;

export type PutApiV1PersonIdContactDataMutationKey = ReturnType<
  typeof putApiV1PersonIdContactDataMutationKey
>;

export function putApiV1PersonIdContactDataMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1PersonIdContactDataMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1PersonIdContactDataMutationKey();
  return mutationOptions<
    PutApiV1PersonIdContactDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdContactData400
      | PutApiV1PersonIdContactData401
      | PutApiV1PersonIdContactData404
      | PutApiV1PersonIdContactData500
    >,
    {
      id: PutApiV1PersonIdContactDataPathParams["id"];
      data?: PutApiV1PersonIdContactDataMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1PersonIdContactData(id, data, config);
    },
  });
}

/**
 * @description Atualiza parcialmente os dados de contato de uma pessoa. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados de contato (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/contact-data}
 */
export function usePutApiV1PersonIdContactData<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1PersonIdContactDataMutationResponse,
      ResponseErrorConfig<
        | PutApiV1PersonIdContactData400
        | PutApiV1PersonIdContactData401
        | PutApiV1PersonIdContactData404
        | PutApiV1PersonIdContactData500
      >,
      {
        id: PutApiV1PersonIdContactDataPathParams["id"];
        data?: PutApiV1PersonIdContactDataMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1PersonIdContactDataMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1PersonIdContactDataMutationKey();

  const baseOptions = putApiV1PersonIdContactDataMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1PersonIdContactDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdContactData400
      | PutApiV1PersonIdContactData401
      | PutApiV1PersonIdContactData404
      | PutApiV1PersonIdContactData500
    >,
    {
      id: PutApiV1PersonIdContactDataPathParams["id"];
      data?: PutApiV1PersonIdContactDataMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1PersonIdContactDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdContactData400
      | PutApiV1PersonIdContactData401
      | PutApiV1PersonIdContactData404
      | PutApiV1PersonIdContactData500
    >,
    {
      id: PutApiV1PersonIdContactDataPathParams["id"];
      data?: PutApiV1PersonIdContactDataMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1PersonIdContactDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdContactData400
      | PutApiV1PersonIdContactData401
      | PutApiV1PersonIdContactData404
      | PutApiV1PersonIdContactData500
    >,
    {
      id: PutApiV1PersonIdContactDataPathParams["id"];
      data?: PutApiV1PersonIdContactDataMutationRequest;
    },
    TContext
  >;
}
